export const letters = [
  {
    letter: "A",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "A",
  },
  {
    letter: "B",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "B",
  },
  {
    letter: "C",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "C",
  },
  {
    letter: "D",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "D",
  },
  {
    letter: "E",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "E",
  },
  {
    letter: "F",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "F",
  },
  {
    letter: "G",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "G",
  },
  {
    letter: "H",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "H",
  },
  {
    letter: "I",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "I",
  },
  {
    letter: "J",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "J",
  },
  {
    letter: "K",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "K",
  },
  {
    letter: "L",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "L",
  },
  {
    letter: "M",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "M",
  },
  {
    letter: "N",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "N",
  },
  {
    letter: "O",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "O",
  },
  {
    letter: "P",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "P",
  },
  {
    letter: "Q",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "Q",
  },
  {
    letter: "R",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "R",
  },
  {
    letter: "S",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "S",
  },
  {
    letter: "T",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "T",
  },
  {
    letter: "U",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "U",
  },
  {
    letter: "V",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "V",
  },
  {
    letter: "W",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "W",
  },
  {
    letter: "Y",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "Y",
  },
  {
    letter: "Z",
    href: "#",
    "aria-label": "Link for letter ...",
    status: "disabled",
    "data-glossary-letter": "Z",
  },
];
